export default __webpack_public_path__ + "static/media/480_store01-nl-mobile.799c6675.png";